module.exports = __webpack_public_path__ + "static/WhenThePastWasAround6-914c88b77ed25918717fc64e5c299b44.webp";